<template>
  <div class="indexNews flex">
    <div class="newsLogos">
      <img src="../../assets/home_news.png" class="logo" />
      <span class="txt">最新资讯</span>
    </div>
    <router-link
      v-for="(news, index) of this.newsList"
      :key="index"
      class="flexItem"
      :to="{ path: '/newsdetail', query: { id: news.id } }"
      target="_blank"
    >
      <b>{{ news.title }}</b>
      <span>{{ news.date }}</span>
    </router-link>
    <router-link to="/news" class="newsAll" target="_blank">全部</router-link>
  </div>
</template>

<script>
// 引入请求类
import { getIndexTopNews } from "../../server/index_top_news";

export default {
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.fetchTopNews();
  },
  methods: {
    async fetchTopNews() {
      let result = await getIndexTopNews();
      this.newsList = result;
    },
  },
};
</script>

<style scoped>
.indexNews {
  width: 1200px;
  height: 58px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
  align-items: center;
  padding-left: 20px;
  padding-right: 30px;
}
.newsLogos {
  display: inline-block;
  margin-right: 63px;
  height: 32px;
  line-height: 32px;
}
.newsLogos .logo {
  display: inline-block;
  width: 32px;
  height: 32px;
  margin-right: 12px;
  vertical-align: middle;
}
.newsLogos .txt {
  color: #f55f5f;
  font-size: 14px;
  font-weight: bold;
  font-style: italic;
}
.flexItem {
  margin-right: 50px;
  overflow: hidden;
}
.flexItem b {
  display: block;
  color: #151515;
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 6px;
}
.flexItem span {
  display: block;
  color: #737373;
  font-size: 12px;
}
.flexItem:hover b {
  color: var(--link-hover-color);
}
.newsAll {
  color: #003399;
  font-size: 12px;
  display: inline-block;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #f1f1f1;
  border-radius: 2px;
  margin-left: 70px;
}
.newsAll:hover {
  background-color: #f0f0ff;
}
.newsAll:before {
  content: "";
  display: inline-block;
  vertical-align: text-bottom;
  width: 14px;
  height: 14px;
  margin-right: 4px;
  background: url(../../assets/icon_menu.png);
  background-size: 100% 100%;
}
</style>